export const SearchIconSvg = ({ fill }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_484_2202)">
        <path
          d="M10.9996 21.9893C1.23546 21.9795 -3.67586 10.1215 3.22147 3.2111C7.31591 -1.05573 14.6833 -1.05642 18.7777 3.21127C25.675 10.1224 20.7631 21.98 10.9996 21.9893ZM10.9996 1.70806C5.88188 1.70806 1.71834 5.87159 1.71834 10.9893C2.22817 23.3021 19.7728 23.2985 20.2808 10.9892C20.2808 5.87164 16.1172 1.70806 10.9996 1.70806ZM12.7183 14.4268C9.87517 14.4268 7.56208 12.1137 7.56208 9.27054C7.84533 2.4301 17.5924 2.43208 17.8746 9.27059C17.8746 12.1137 15.5615 14.4268 12.7183 14.4268ZM12.7183 5.83305C10.8229 5.83305 9.28083 7.37511 9.28083 9.27054C9.46963 13.8309 15.9677 13.8295 16.1558 9.2705C16.1558 7.37511 14.6138 5.83305 12.7183 5.83305ZM6.10123 16.6182C5.87732 16.6182 5.65367 16.5313 5.48523 16.3581C5.15425 16.0179 5.16172 15.4738 5.50186 15.1429L7.0917 13.596C7.43193 13.2651 7.97596 13.2726 8.30694 13.6127C8.63793 13.9528 8.63045 14.4969 8.29031 14.8279L6.70047 16.3748C6.53341 16.5373 6.31715 16.6182 6.10123 16.6182ZM14.48 9.27054C14.48 8.29915 13.6897 7.50883 12.7183 7.50883C11.5783 7.55416 11.5788 9.1825 12.7183 9.22757C12.742 9.22757 12.7613 9.24682 12.7613 9.27054C12.7613 9.74518 13.146 10.1299 13.6207 10.1299C14.0953 10.1299 14.48 9.74518 14.48 9.27054Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_484_2202">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
